import React from 'react';
import { Flex, Text, Box } from '@radix-ui/themes';

interface TopBarProps {
  title: string;
  showActions?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ title, showActions = false }) => {
  return (
    <Box
      data-topbar-container
      style={{
        position: 'fixed',
        top: 0,
        left: '250px', // Account for sidebar width
        right: 0,
        height: '64px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e5e7eb',
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        padding: '0 2rem',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Flex 
        align="center" 
        justify={showActions ? "between" : "center"} 
        width="100%"
      >
        {showActions && <Box style={{ width: '32px' }} />} {/* Spacer for centering when actions exist */}
        
        <Text 
          size="8" 
          weight="bold" 
          style={{ 
            color: '#1a1a1a',
            fontSize: '2rem',
            textAlign: 'center'
          }}
        >
          {title}
        </Text>
        
        {showActions && (
          <Flex align="center" gap="3">
            {/* Notification button disabled until functionality is implemented */}
            {/* <Box
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
            >
              <Text size="1">🔔</Text>
            </Box> */}
          </Flex>
        )}
      </Flex>
      
      {/* Mobile responsive styles */}
      <style>{`
        @media (max-width: 768px) {
          [data-topbar-container] {
            left: 0 !important;
            padding: 0 1rem !important;
            top: 0 !important;
          }
        }
        
        @media (min-width: 769px) and (max-width: 1024px) {
          [data-topbar-container] {
            left: 220px !important;
          }
        }
      `}</style>
    </Box>
  );
};

export default TopBar; 